import React from "react";
import "antd/dist/antd.css";
import { CloseOutlined, CheckOutlined } from "@ant-design/icons";
import { Popover, Button, Row, Col } from "antd";
import "./customStyle.css";
import _ from "lodash";
import { connect } from "react-redux";

class SignatureAllPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // visible: false,
      visible: this.props.visible,
      allReports: {
        Daily: [{ reportName: "", type: " " }],
        Weekly: [{ reportName: "", type: " " }],
      },
      isDailyAvailable: false,
      isWeeklyAvailable: false,
      isMonthlyAvailable: false,
      isQuarterlyAvailable: false,
      isYearlyAvailable: false,
      isBiAnnuallyAvailable: false,
    };
  }

  hide = () => {
    // this.props.onHide(false);
    this.setState({ visible: false }, () => this.props.onHide(false));
    //     this.setState({
    //         visible: false,
    //     },()=>{this.props.onHide(false)});
    // };
  };

  handleVisibleChange = (visible) => {
    // this.setState({ visible: true });
    this.setState({ visible: visible });
    // this.setState({ visible }, () => { this.props.onHide(false) });
  };

  componentDidUpdate(prevProp, prevState) {
    if (
      this.props.visible !== undefined &&
      this.props.visible !== prevProp.visible
    ) {
      if (this.props.reportContent !== undefined) {
        let missing_reports = this.props.reportContent.mis_reports
          .map((item) => {
            return {
              ...item,
              type: "missing",
            };
          })
          .filter(
            (i) => i.signatureRequired === true && i.excludeSigReport === false
          );

        let upload_reports = this.props.reportContent.up_reports
          .map((item) => {
            return {
              ...item,
              type: "upload",
            };
          })
          .filter(
            (i) => i.signatureRequired === true && i.excludeSigReport === false
          );

        const temp = [...missing_reports, ...upload_reports];

        temp.sort(function (a, b) {
          return a.reportName.toUpperCase() > b.reportName.toUpperCase()
            ? 1
            : -1;
        });

        // console.log('final report on popup', _.groupBy(temp, 'scheduleType'));
        this.all_reports = _.groupBy(temp, "scheduleType");
        this.isDailyAvailable = this.isValidCategory(this.all_reports["Daily"]);
        this.isWeeklyAvailable = this.isValidCategory(
          this.all_reports["Weekly"]
        );
        this.isMonthlyAvailable = this.isValidCategory(
          this.all_reports["Monthly"]
        );
        this.isQuarterlyAvailable = this.isValidCategory(
          this.all_reports["Quarterly"]
        );
        this.isYearlyAvailable = this.isValidCategory(
          this.all_reports["Yearly"]
        );
        this.isBiAnnuallyAvailable = this.isValidCategory(
          this.all_reports["Bi-Annually"]
        );
      }
      this.setState({
        // visible: this.props.visible,
        allReports: this.all_reports,
        isDailyAvailable: this.isDailyAvailable,
        isWeeklyAvailable: this.isWeeklyAvailable,
        isMonthlyAvailable: this.isMonthlyAvailable,
        isQuarterlyAvailable: this.isQuarterlyAvailable,
        isYearlyAvailable: this.isYearlyAvailable,
        isBiAnnuallyAvailable: this.isBiAnnuallyAvailable,
      });
    }
  }

  isValidCategory(category) {
    let temp = category || false;
    if (temp) {
      temp = temp.length !== 0 ? true : false;
    }
    return temp;
  }

  render() {
    const content = (
      <div className="popupContainer">
        {/* <a className="popupClose" onClick={this.hide}><CloseOutlined /></a> */}
        {this.state.isDailyAvailable && (
          <div className="subSection">
            <div className="title">Daily</div>
            <Row gutter={[16, 16]}>
              <Col>
                {this.state.allReports["Daily"] !== undefined
                  ? this.state.allReports["Daily"].map((item) => (
                      <p>
                        <span
                          className={`status ${
                            item.type === "missing" ? "missing" : "available"
                          }`}
                        >
                          {item.type === "missing" ? (
                            <CloseOutlined />
                          ) : (
                            <CheckOutlined />
                          )}
                        </span>
                        {item.reportName}
                      </p>
                    ))
                  : ""}
              </Col>
              <Col></Col>
            </Row>
          </div>
        )}
        {this.state.isWeeklyAvailable && (
          <div className="subSection">
            <div className="title">Weekly</div>
            <Row gutter={[16, 16]}>
              <Col>
                {this.state.allReports["Weekly"] !== undefined
                  ? this.state.allReports["Weekly"].map((item) => (
                      <p>
                        <span
                          className={`status ${
                            item.type === "missing" ? "missing" : "available"
                          }`}
                        >
                          {item.type === "missing" ? (
                            <CloseOutlined />
                          ) : (
                            <CheckOutlined />
                          )}
                        </span>
                        {item.reportName}
                      </p>
                    ))
                  : ""}
              </Col>
            </Row>
          </div>
        )}
        {this.state.isMonthlyAvailable && (
          <div className="subSection">
            <div className="title">Monthly</div>
            <Row gutter={[16, 16]}>
              <Col>
                {this.state.allReports["Monthly"] !== undefined
                  ? this.state.allReports["Monthly"].map((item) => (
                      <p>
                        <span
                          className={`status ${
                            item.type === "missing" ? "missing" : "available"
                          }`}
                        >
                          {item.type === "missing" ? (
                            <CloseOutlined />
                          ) : (
                            <CheckOutlined />
                          )}
                        </span>
                        {item.reportName}
                      </p>
                    ))
                  : ""}
              </Col>
            </Row>
          </div>
        )}
        {this.state.isQuarterlyAvailable && (
          <div className="subSection">
            <div className="title">Quarterly</div>
            <Row gutter={[16, 16]}>
              <Col>
                {this.state.allReports["Quarterly"] !== undefined
                  ? this.state.allReports["Quarterly"].map((item) => (
                      <p>
                        <span
                          className={`status ${
                            item.type === "missing" ? "missing" : "available"
                          }`}
                        >
                          {item.type === "missing" ? (
                            <CloseOutlined />
                          ) : (
                            <CheckOutlined />
                          )}
                        </span>
                        {item.reportName}
                      </p>
                    ))
                  : ""}
              </Col>
            </Row>
          </div>
        )}
        {this.state.isBiAnnuallyAvailable && (
          <div className="subSection">
            <div className="title">Bi-Annually</div>
            <Row gutter={[16, 16]}>
              <Col>
                {this.state.allReports["Bi-Annually"] !== undefined
                  ? this.state.allReports["Bi-Annually"].map((item) => (
                      <p>
                        <span
                          className={`status ${
                            item.type === "missing" ? "missing" : "available"
                          }`}
                        >
                          {item.type === "missing" ? (
                            <CloseOutlined />
                          ) : (
                            <CheckOutlined />
                          )}
                        </span>
                        {item.reportName}
                      </p>
                    ))
                  : ""}
              </Col>
            </Row>
          </div>
        )}
        {this.state.isYearlyAvailable && (
          <div className="subSection">
            <div className="title">Yearly</div>
            <Row gutter={[16, 16]}>
              <Col>
                {this.state.allReports["Yearly"] !== undefined
                  ? this.state.allReports["Yearly"].map((item) => (
                      <p>
                        <span
                          className={`status ${
                            item.type === "missing" ? "missing" : "available"
                          }`}
                        >
                          {item.type === "missing" ? (
                            <CloseOutlined />
                          ) : (
                            <CheckOutlined />
                          )}
                        </span>
                        {item.reportName}
                      </p>
                    ))
                  : ""}
              </Col>
            </Row>
          </div>
        )}
      </div>
    );

    return (
      <Popover
        content={<div>{content}</div>}
        visible={this.state.visible}
        onVisibleChange={this.handleVisibleChange}
        title={
          <div>
            Signature Reports
            <br />
            {this.props.transpose === "horizontal"
              ? this.props.hname
              : this.props.bdate}
          </div>
        }
        placement="left"
        trigger="click"
        arrowPointAtCenter
      >
        {this.props.innerContent}
        {/* <span style={{height:'25px',width:'15px'}}></span> */}
      </Popover>
    );
  }
}

function mapStateToProps(state) {
  return {
    transpose: state.complianceTableReducer.transpose,
  };
}

export default connect(mapStateToProps)(SignatureAllPopup);
